import {on, find, closest, removeClass, addClass, hasClass, findIn, removeAttribute, setAttribute, findAllIn} from "@elements/dom-utils";
import axios from "axios";
import TerracePlanner from "../index";
import {visualizeCompleteness, setTabData, updateTab, unCompleteTab, completeTab, switchTab} from "../tabManager";
import {selectSet, isFrame} from "./substructureFrame";
import {openAdditionalInfo} from "./substructureSlides";
import {translate} from '@elements/translations';

let backendUrl = window.location.protocol + '//' + window.location.hostname + '/terraceplanner/subStructure/';
let minHeightInput, maxHeightInput, stockOnlyNode;
export function init() {
    if (findAllIn('.js-planner__submit-substructure', TerracePlanner.element)) {
        findAllIn('.js-planner__submit-substructure', TerracePlanner.element).map((item) => {
            if (item.getAttribute('data-submit-type') === 'complete') {
                on('click', (evt) => subStructureCompleteListener(item), item);
            } else {
                on('click', (evt) => noSubStructureListener(item), item);
            }
        });
    }

    if (findAllIn('.js-planner__substructure-select', TerracePlanner.element)) {
        findAllIn('.js-planner__substructure-select', TerracePlanner.element).map((item) => {
            on('click', (evt) => tabUpdateListener(item), item);
        });
    }

    if (findAllIn('.js-planner__construction-underground', TerracePlanner.element)) {
        findAllIn('.js-planner__construction-underground', TerracePlanner.element).map((item) => {
            on('click', (evt) => {
                if (findAllIn('.js-planner__construction-underground', TerracePlanner.element)) {
                    findAllIn('.js-planner__construction-underground', TerracePlanner.element).map((item) => {
                        removeClass('is-selected', item);
                        removeClass('is-not-selected', item);
                    });
                }

                addClass('is-selected', item);

                undergroundSelectionListener(item);
            }, item);
        });
    }

    stockOnlyNode = find('#substructure-stock-only');
    if (stockOnlyNode) {
        on('change', (evt) => stockOnlyListener(stockOnlyNode), stockOnlyNode);
    }

    if (findAllIn('.js-planner__construction-input', TerracePlanner.element)) {
        findAllIn('.js-planner__construction-input', TerracePlanner.element).map((item) => {
            on('change', (evt) => {
                if (item.checked && item.getAttribute('data-slope-direction')) {
                    switchSlope(item, item.getAttribute('data-slope-direction'))
                }

                if (item.checked && item.getAttribute('data-target-fieldset') === 'none') {
                    TerracePlanner.tabConfig.subStructure.subStructureSetId = null;
                }
            }, item);
        })
    }
    // $('#slopDirectionHorizontalRadio').on('change', switchSlope);
    // if (find('#slopDirectionVerticalRadio')) {
    //     on('change', (evt) => switchSlope(), find('#slopDirectionVerticalRadio'));
    // }
    // $('#slopDirectionVerticalRadio').on('change', switchSlope);

    console.log(findAllIn('.is-disabled .js-planner__slope-input', TerracePlanner.element))
    if (findAllIn('.is-disabled .js-planner__slope-input', TerracePlanner.element)) {
        findAllIn('.is-disabled .js-planner__slope-input', TerracePlanner.element).map((input) => setAttribute('disabled', true, input));
    }

    // minHeightInput = findIn('#slopeMin');
    minHeightInput = findIn('.js-planner__slope-input[data-slope="min"]:not(:disabled)', TerracePlanner.element);
    maxHeightInput = findIn('.js-planner__slope-input[data-slope="max"]:not(:disabled)', TerracePlanner.element);
    // maxHeightInput = find('#slopeMax');

    if (findAllIn('.js-planner__slope-input', TerracePlanner.element)) {
        findAllIn('.js-planner__slope-input', TerracePlanner.element).map((input) => {
            on('input', (evt) => levelingFeetValidationListener(evt), input);
        });
    }
    // minHeightInput.on('input', levelingFeetValidationListener);
    // if (maxHeightInput) {
    //     on('input', (evt) => levelingFeetValidationListener(), maxHeightInput);
    // }
    // maxHeightInput.on('input', levelingFeetValidationListener);

    if(TerracePlanner.tabConfig.subStructure.complete) {
        subStructureUpdateTab(TerracePlanner.tabConfig.subStructure.subStructureSetId);
        subStructureUpdateTabData();
        visualizeCompleteness('subStructure');
    }

    initWarnings();
}

/**
 * validates whether leveling feet heights are within the boundaries specified in the TerracePlanner object
 * and shows the appropriate message for the first failed validation
 *
 * Order: max height -> min height -> height difference
 *
 * @param event
 */
function levelingFeetValidationListener(event) {
    minHeightInput = findIn('.js-planner__slope-input[data-slope="min"]:not(:disabled)', TerracePlanner.element);
    maxHeightInput = findIn('.js-planner__slope-input[data-slope="max"]:not(:disabled)', TerracePlanner.element);

    let maxHeightValue = Number(maxHeightInput.value);
    let minHeightValue = Number(minHeightInput.value);

    let maxHeight = Number(maxHeightInput.getAttribute('max'));
    let minHeight = Number(minHeightInput.getAttribute('min'));

    // Disable the complete button if any limit is reached.
    let substructureCompleteButton = findIn('.js-planner__submit-substructure[data-submit-type="complete"]', TerracePlanner.element);
    removeAttribute('disabled', substructureCompleteButton);
    // substructureCompleteButton.prop( "disabled", false );

    findAllIn('.js-planner__slope-alert', TerracePlanner.element).map((alert) => {
        setAttribute('hidden', true, alert);
    });

    if (maxHeightValue === 0 && minHeightValue === 0) {
        return
    }

    if(maxHeightValue > maxHeight) {
        removeAttribute('hidden', find('#maxHeightReached'));
        setAttribute('disabled', true, substructureCompleteButton);
    }

    if(minHeightValue > maxHeight) {
        removeAttribute('hidden', find('#maxHeightReached'));
        setAttribute('disabled', true, substructureCompleteButton);
    }

    if(minHeightValue < minHeight) {
        removeAttribute('hidden', find('#minHeightReached'));
        setAttribute('disabled', true, substructureCompleteButton);
    }

    if(maxHeightValue < minHeight) {
        removeAttribute('hidden', find('#minHeightReached'));
        setAttribute('disabled', true, substructureCompleteButton);
    }
}

/**
 * shows the alert box belonging to a newly selected type of underground
 * and hides the old one
 *
 * @param event
 */
function undergroundSelectionListener(item) {
    let label = closest('.js-planner__construction-underground', item);

    findAllIn('.js-planner__constructio-underground-alert', TerracePlanner.element).map((alertBox) => {
        setAttribute('hidden', true, alertBox);
    });

    removeAttribute('hidden', findIn('[data-for='+ label.getAttribute('id') +']', TerracePlanner.element));
}

/**
 * push the currently selected item (image, name) to the subStructure tab
 *
 * @param selectedSetId the selected subStructure set
 */
export function subStructureUpdateTab(selectedSetId) {
    let previousItem = find('.js-planner__substructure.is-selected');
    if (previousItem) {
        removeClass('is-selected', previousItem);
    }

    let selectedItem = find('.js-planner__substructure[data-set-id="'+ selectedSetId +'"]');
    if (selectedItem) {
        addClass('is-selected', selectedItem);
    }

    let text = selectedItem ? findIn('.js-planner__construction-material', selectedItem).getAttribute('data-tab-title') : translate('terracePlanner.subStructure.none');
    updateTab('subStructure', text);
}

/**
 * listener to determine the currently selected subStructure set and call updateTab with its id
 *
 * @param event
 */
function tabUpdateListener(item) {
    if (findAllIn('.js-planner__substructure', TerracePlanner.element)) {
        findAllIn('.js-planner__substructure', TerracePlanner.element).map((item) => {
            removeClass('is-not-selected', item);
        });
    }

    if(hasClass('.btn-info, .icon-info', item)) {
        return;
    }

    let setIdNode = closest('[data-set-id]', item);
    let setId = setIdNode.getAttribute('data-set-id');
    TerracePlanner.tabConfig.subStructure.subStructureSetId = setId;
    selectSet(setId);
    subStructureUpdateTab(setId);
    openAdditionalInfo();
    initWarnings();
}

/**
 * listener to not select a subStructureSet or to un-select a previous set
 *
 * @param event
 */
function noSubStructureListener() {
    updateTab('subStructure', translate('terracePlanner.subStructure.none'));
    setTabData('subStructure', {screwingVisibility: 'none'});
    unCompleteTab('product');
    unCompleteTab('plankPattern');
    completeTab('subStructure', 'product');
}

/**
 * sends a boolean value to the backend whether or not only substructure sets in stock should be used
 * then uses the tab manager to reload the panel
 *
 * @param event
 */
function stockOnlyListener(input) {
    let stockOnly = input.checked;

    axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        url: backendUrl + 'in-stock?stock_only=' + (stockOnly ? 'true' : ''),
        responseType: 'json'
    }).then(({data: {success, data}}) => {
        if(stockOnly) {
            unCompleteTab('subStructure');
            unCompleteTab('product');
            switchTab('product');
        } else {
            unCompleteTab('subStructure');
            switchTab('subStructure');
        }
    });

    // $.ajax(backendUrl + 'in-stock?stock_only=' + (stockOnly ? 'true' : ''), {
    //     success: function () {
    //         if(stockOnly) {
    //             terracePlannerTabManager.unCompleteTab('subStructure');
    //             terracePlannerTabManager.unCompleteTab('product');
    //             terracePlannerTabManager.switchTab('product');
    //         } else {
    //             terracePlannerTabManager.unCompleteTab('subStructure');
    //             terracePlannerTabManager.switchTab('subStructure');
    //         }
    //     }
    // });
}

/**
 * collects selected data across the subStructure panel and passes it to the tabManager
 * which in turn synchronizes the data with the backend
 *
 */
function subStructureUpdateTabData() {
    let selectedSet = findIn('.js-planner__substructure.is-selected', TerracePlanner.element);
    let selectedUndergroundInput = findIn('.js-planner__construction-underground input:checked', TerracePlanner.element);
    let selectedSetId = selectedSet ? selectedSet.getAttribute('data-set-id') : '';
    let selectedUnderground = selectedUndergroundInput ? selectedUndergroundInput.value : '';

    let slopeDirection = findIn('.js-planner__construction-input[data-slope-direction]:checked', TerracePlanner.element).getAttribute('data-slope-direction');

    setTabData('subStructure', {
        setId: selectedSetId,
        asFrame: isFrame(),
        underground: selectedUnderground,
        minHeight: minHeightInput.value,
        maxHeight: maxHeightInput.value,
        slopeDirection: slopeDirection
    });

}

/**
 * listener to update the substructure tab and switch to the next
 *
 * @param event
 */
function subStructureCompleteListener(event) {
    subStructureUpdateTabData();
    unCompleteTab('product');
    unCompleteTab('plankPattern');
    completeTab('subStructure', 'product');
}

/**
 * shows leveling feet validations and tips for the chosen underground if those things have already been selected
 * when the tab was loaded
 */
function initWarnings() {
    if(minHeightInput && '' !== minHeightInput.value || maxHeightInput && '' !== maxHeightInput.value) {
        levelingFeetValidationListener(null);
    }

    let preselectedUnderground = find('.radio-construction-underground:checked');
    if(preselectedUnderground && 0 < preselectedUnderground.length) {
        undergroundSelectionListener(preselectedUnderground[0]);
    }
}

function switchSlope(item, direction) {
    let verticalContainer = findIn('.planer__slope-edit--vertical', TerracePlanner.element);
    let horizontalContainer = findIn('.planer__slope-edit--horizontal', TerracePlanner.element);

    if(direction === 'horizontal') {
        removeClass('is-disabled', horizontalContainer);
        addClass('is-disabled', verticalContainer);

        findAllIn('.js-planner__slope-input', verticalContainer).map((input) => {
            setAttribute('disabled', true, input);
        });

        findAllIn('.js-planner__slope-input', horizontalContainer).map((input) => {
            removeAttribute('disabled', input)
        });
    } else {
        removeClass('is-disabled', verticalContainer);
        addClass('is-disabled', horizontalContainer);

        findAllIn('.js-planner__slope-input', horizontalContainer).map((input) => {
            setAttribute('disabled', true, input);
        });

        findAllIn('.js-planner__slope-input', verticalContainer).map((input) => {
            removeAttribute('disabled', input);
        });
    }
}